module.exports = {
  momentFormat: 'DD/MM/YYYY',
};
